export const navMap = [
  {
    id: '1',
    path: '/analytics/dashboard',
    label: 'Аналитика',
  },
];
